import { data } from 'services';

export const getTableParams = (t) => {
  const setActions = [];

  // get row class
  const getRowClass = (row) => {
    let out = '';
    out += ' ' + (row.is_active ? 'active' : 'blocked');
    return out;
  };

  const getFields = () => {
    const fields = [
      { name: 'username', title: t('form.Логин'), width: 140 },
      { name: 'role', title: t('form.Роль'), width: 190 },
      { name: 'is_active', title: t('dict_filter.Статус'), width: 130, render: (val) => data.getDictValue('users.status', val) },
      { name: 'name', title: t('form.ФИО') },
      { name: 'email', title: t('form.E-mail'), width: 180 },
      { name: 'phone', title: t('grid.Телефон'), width: 180, align: 'right' },
    ];

    return fields;
  };

  return { getFields, getRowClass, setActions };
};
